<div ui-view>
    <neo-list data="vm.data"></neo-list>
    <div layout-padding>
        <neo-action-button buttons="vm.buttons" ng-if="vm.hasPermission"></neo-action-button>
    </div>
</div>
